import { render } from "./bidangPengelolaanSampah.vue?vue&type=template&id=64b83a38"
import script from "./bidangPengelolaanSampah.vue?vue&type=script&lang=js"
export * from "./bidangPengelolaanSampah.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__